import React from 'react'
import { IQuestion, IResponse } from 'models'
import Multi from './Multi'
import Range from './Range'
import Single from './Single'

export interface IQuestionProps {
  question: IQuestion
  onChange: (answers: IResponse['answers']) => void
}

const Question = (props: IQuestionProps) => {
  switch (props.question.type) {
    case 'range':
      return <Range {...props} />
    case 'multi':
      return <Multi {...props} />
    case 'single':
      return <Single {...props} />
    default:
      return <p style={{ color: 'red' }}>Error loading question...</p>
  }
}

export default Question
